<template>
  <v-nav/>
  <select-personal @selectPersonal="selectPersonal"/>
  <a-row>
    <a-col :span="7" style="padding: 0 12px;">
      <page-title style="position:fixed;" :brain-type="$t('personalBrain')" :menu-name="$t('fibreTrack')"/>
      <div class="condition-content cibr-self">
        <div class="option-panel" style="margin-bottom: 12px">
          <a-row type="flex" justify="space-around" align="middle" :gutter="16">
            <a-col :span="8">
              <select-id-and-name :list="personalList"
                                  option-text="name" option-value="id"
                                  v-model:value="personalId">
              </select-id-and-name>
            </a-col>
            <a-col :span="6">
              <a-checkbox v-model:checked="showBrain">{{ $t("showSurface") }}</a-checkbox>
            </a-col>
            <a-col :span="10">
              <a-slider id="test" v-model:value="opacity" :disabled="!showBrain" :min="0" :max="0.3" :step="0.001"/>
            </a-col>
          </a-row>
        </div>
        <fibre-select v-model:value="selectList"></fibre-select>
      </div>
    </a-col>
    <a-col :span="17">
      <div id="personalFibre" style="width: 100%" :style="{height:contentHeight}">
      </div>
    </a-col>
  </a-row>
  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/12/15 14:00
import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import VNav from "@/components/public/VNav.vue";
import SelectPersonal from "@/components/public/selectPersonal.vue";
import PageTitle from "@/components/public/pageTitle.vue";
import SelectIdAndName from "@/components/public/selectIdAndName.vue";
import vtkUtil from "@/util/vtkUtil";
import FibreSelect from "@/components/public/fibreSelect.vue";

export default {
  name: "personalFibre",
  components: {FibreSelect, SelectIdAndName, PageTitle, SelectPersonal, VNav, VLoading},
  data() {
    return {
      loading: false,
      personalId: "",
      personalList: [],
      contentHeight: "",
      selectList: [],

      renderer: null,
      renderWindow: null,
      existsModal: {},
      showBrain: false,
      opacity: 0.1,
      mashBrain: {}
    }
  },
  mounted() {
    this.initPage();
  },
  beforeMount() {
    this.computedHeight();
    window.onresize = this.computedHeight
  },
  methods: {
    computedHeight() {
      this.contentHeight = (window.innerHeight - 48) + "px";
    },
    selectPersonal(personalId) {
      this.personalId = personalId;
      this.drawBrain();
    },
    drawBrain() {
      var vtkWindow = vtkUtil.init3DWindow("personalFibre");
      this.renderer = vtkWindow.renderer;
      this.renderWindow = vtkWindow.renderWindow;
      // vtkUtil.readObjMode(util.personalUrl + this.personalId + "/surface.obj",
      //     this.renderer, this.renderWindow, () => {
      //     });
      // vtkUtil.getVtkActor2(util.personalUrl + this.personalId + "/all.vtk", (res)=>{
      //   vtkUtil.smallNav(this.renderer, this.renderWindow, res.actor);
      // })
      this.reloadMash();
      // vtkUtil.getObjActor(util.baseUrl + "BrainMesh_Ch2.obj", (res)=>{
      //   vtkUtil.smallNav(this.renderer, this.renderWindow, res.actor);
      // })
      this.loadAllBrain();
    },
    reloadMash(){
      vtkUtil.getObjActor(util.personalUrl + this.personalId + "/surface.obj", (res) => {
        vtkUtil.smallNav(this.renderer, this.renderWindow, res.actor);
      })
      vtkUtil.getObjActor(util.personalUrl + this.personalId + "/surface.obj", (res) => {
        this.mashBrain = res.actor;
      })
    },
    loadAllBrain() {
      this.showMask();
      vtkUtil.readVtkFile(util.personalUrl + this.personalId + "/all.vtk",
        this.renderer, this.renderWindow, 0.01, () => {
          this.renderer.resetCamera();
          this.renderWindow.render();
          this.hideMask();
        });
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      var post = {
        personalId: this.personalId
      }
      util.$post("/personal/fibre/initPage", post, (res) => {
        this.personalList = res.personalList;
      }, this.showMask, this.hideMask);
    },
    loadNewModal(modal) {
      // var list = [...util.associationList(), ...util.projectionList(), ...util.commissuralList(),
      //     ...util.cerebellumList(), ...util.cranialList()]
      // var filter = list.filter(item => modal === item.value)[0].label;
      var personalName = this.personalList.filter(item => this.personalId === item.id)[0].name;
      var name = personalName + "_ses-001_space-T1w_desc-preproc_dwigqi." + modal + "_ds_0.5_4";
      vtkUtil.readVtkFile(util.personalUrl + this.personalId + "/" + name + ".vtk",
        this.renderer, this.renderWindow, 1, (res) => {
          this.existsModal[modal] = res.actor;
          this.renderWindow.render();
        });
    },
    showNewModal(modalList) {
      if (util.isNull(modalList)) {
        return;
      }
      modalList.map(item => {
        var actor = this.existsModal[item];
        if (util.isNull(actor)) {
          this.loadNewModal(item);
        } else {
          this.renderer.addActor(actor);
        }
      })
      this.renderWindow.render();
    },
    removeModal(oldModal) {
      if (util.isNull(oldModal)) {
        return;
      }
      console.log(oldModal)
      oldModal.map(item => {
        this.renderer.removeActor(this.existsModal[item]);
      })
      this.renderWindow.render();
    }
  },
  watch: {
    personalId() {
      if (util.isNull(this.renderer)) {
        return;
      }
      this.renderer.getActors().map(item => {
        this.renderer.removeActor(item);
      })
      this.selectList = [];
      this.existsModal = {};
      this.showBrain = false;
      this.reloadMash();
      this.loadAllBrain();
    },
    newList(newVal, oldVal) {
      console.log(newVal, oldVal);
      var newModal = newVal.filter(item => !oldVal.includes(item));
      this.showNewModal(newModal);
      var oldModal = oldVal.filter(item => !newVal.includes(item));
      this.removeModal(oldModal);
    },
    opacity(){
      this.mashBrain.getProperty().setOpacity(this.opacity);
      this.renderWindow.render();
    },
    showBrain(){
      if (this.showBrain){
        this.mashBrain.getProperty().setOpacity(this.opacity);
        this.renderer.addActor(this.mashBrain);
      }else {
        this.renderer.removeActor(this.mashBrain)
      }
      this.renderWindow.render();
    }
  },
  computed: {
    newList() {
      return JSON.parse(JSON.stringify(this.selectList))
    },

  }
}
</script>

<style scoped>
.condition-content {
    /*background-color: #5A2781;*/
    /*border-radius: 20px;*/
    /*border: 1px #552D6D solid;*/
    position: absolute;
    top: 40px;
    margin-top: 70px;
    /*padding: 16px 16px;*/
    width: 100%;
}
</style>